
import { Box } from "@mui/material";
import { t } from "i18next";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { ListRenderer } from "../../components";
import CreateButton from "../../components/Admin/createButton";
import CommonContainer from "../../components/common/container/CommonContainer";


const List: React.FC = () => {
    const { t } = useTranslation('translation');

    return (
            <CommonContainer title={t("ticketListingPageTitle")} description={t("ticketListingPageDescription")}>
            <Box className="w-full" display="flex" flexDirection="row-reverse" justifyContent="flex-start">
                <CreateButton />
            </Box>
            <ListRenderer />
            </CommonContainer>
    );
};

export default List;
